import { _, Backbone, moment, Radio, Foundation } from "../../../vendor";
import { Backform, Biscuit } from "../../utils";
import InboomaBaseView from "../InboomaBaseView";
import { appRollingLoaderAnim } from "../AppAnnouncements";
import "../../../vendor/Blob";
import { getApiHost } from "../../Sync";
import * as FileSaver from "../../../vendor/FileSaver";

import OrdersExportTpl from "../../templates/orders/OrdersExportTpl.html";

export default InboomaBaseView.extend({
  el: "#orders-export-form",
  template: OrdersExportTpl,

  ui: {
    formErrorDiv: ".off-canvas__form-error",
  },

  initialize() {
    this.render();
  },

  onRender() {
    const that = this,
      formErrorDiv = this.getUI("formErrorDiv"),
      locations = Radio.channel("locations").request("get:data");

    const model = new Backbone.Model({
      type: "normal", // not used as of now
      date: new Date(),
      location: null,
    });

    let managerHasLocations = Biscuit.get("user.user_locations");

    if (managerHasLocations !== "") {
      managerHasLocations = managerHasLocations.split(",");
    }

    let locationsOptions = [];

    _.map(locations.models, (location) => {
      if (managerHasLocations.length && !_.contains(managerHasLocations, location.id.toString())) {
        return;
      }

      locationsOptions.push({
        label: location.get("name"),
        value: location.get("id"),
      });
    });

    const fields = [
      /*{
                name: "type",
                label: this.t('rental_contract_type'),
                control: "select",
                options: [
                    { label: this.t('rental_contract_type_normal'), value: 'normal' },
                    { label: this.t('rental_contract_type_slowup'), value: 'slowup' }
                ],
                size: {
                    "large" : "3"
                }
            },*/
      {
        name: "date",
        label: this.t("date", null, "capital"),
        control: "datepicker",
        size: {
          large: "4",
        },
      },
      {
        // @todo If not all locations are shown, change control to
        // inboomaselect, as done at same place
        // in OrdersSalesBillingsView.js
        name: "location",
        label: this.t("location", null, "capital"),
        control: "selector",
        required: true,
        forceFirstSelected: true,
        options: locationsOptions,
        size: {
          large: "6",
        },
      },
      {
        label: this.t("generate", null, "capital"),
        control: "button",
        extraClasses: ["button-submit"],
      },
    ];

    const form = new Backform.Form({
      el: that.$el.find("form"),
      model,
      fields,
      events: {
        "click .button-submit"(ev) {
          ev.preventDefault();

          formErrorDiv.addClass("hide");

          const date = moment(model.get("date"));
          //slowup = model.get('type') === 'slowup' ? '&slowup=true' : '';

          if (!date.isValid()) {
            // @todo Communicate errors more cleary
            formErrorDiv.html(that.t("invalid_time_format")).removeClass("hide");
            return;
          }

          that.$el.find(".button-submit").prepend(appRollingLoaderAnim);

          const xmlHttp = new XMLHttpRequest();

          xmlHttp.open(
            "GET",
            getApiHost() +
              "/reservations/getRentalContractForLocation?download=true&date=" +
              date.format("YYYY-MM-DD") +
              "&location_id=" +
              model.get("location") /*+ slowup*/,
            true,
          );

          xmlHttp.setRequestHeader("Accept", "application/json");
          xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
          xmlHttp.responseType = "blob";

          xmlHttp.onload = function () {
            that.$(".button-submit img").remove();

            if (xmlHttp.status === 500 || xmlHttp.status === 400) {
              formErrorDiv.html("rental_contract_error").removeClass("hide");
              return;
            }

            if (
              xmlHttp.status === 404 ||
              (typeof xmlHttp.response.size !== "undefined" && xmlHttp.response.size === 1229)
            ) {
              formErrorDiv.html(that.t("rental_contract_error_empty")).removeClass("hide");
              return;
            }

            const blob = new Blob([xmlHttp.response], {
              type: "application/pdf",
            });
            let location = Radio.channel("locations")
              .request("get:data")
              .get(model.get("location"));
            FileSaver.saveAs(
              blob,
              that.t("rental_contract_location") +
                " " +
                location.get("name").replace(/\s/g, "_") +
                ".pdf",
            );
          };

          xmlHttp.send(null);
        },
      },
    }).render();

    this.modal = new Foundation.Reveal(this.$el);

    this.modal.open();

    this.$el.on("closed.zf.reveal", () => {
      Radio.channel("app").trigger("destroy:backform"); // Remove pikaday from DOM

      that.$el.foundation("_destroy");

      that.unbind();
      that.undelegateEvents();
      that.unbindEvents();
      that.unbindUIElements();

      Backbone.history.navigate("orders", { trigger: true });
      that.$el.off("closed.zf.reveal");
    });
  },
});
